import { SET_SELECTED_ARRIVAL_PORT } from '../actions/actionTypes';

const initialState: string = '';

export const destinationPortReducer = (state: string = initialState, action: any) => {
  switch (action.type) {
    case SET_SELECTED_ARRIVAL_PORT:
      return action.data;
    default:
     return state;
  };
};
